/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminSecurityEstimateResponse } from '../models/AdminSecurityEstimateResponse';
import type { AdminSecurityRequestDetailResponse } from '../models/AdminSecurityRequestDetailResponse';
import type { SecurityCatalogItemResponse } from '../models/SecurityCatalogItemResponse';
import type { SecurityCatalogResponse } from '../models/SecurityCatalogResponse';
import type { SecurityConfigurationDto } from '../models/SecurityConfigurationDto';
import type { SecurityPricingSettingsResponse } from '../models/SecurityPricingSettingsResponse';
import type { SecurityRequestCountsResponse } from '../models/SecurityRequestCountsResponse';
import type { SecurityRequestStatus } from '../models/SecurityRequestStatus';
import type { SecurityRequestType } from '../models/SecurityRequestType';
import type { UpdateSecurityCatalogItemDto } from '../models/UpdateSecurityCatalogItemDto';
import type { UpdateSecurityPricingSettingsDto } from '../models/UpdateSecurityPricingSettingsDto';
import type { UpdateSecurityRequestDto } from '../models/UpdateSecurityRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DashboardSecurityService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List client security requests
     * Paginated list of the requests sent from the client app (new system, study, complement, repair), newest first.
     * @returns any
     * @throws ApiError
     */
    public securityDashboardControllerFindAll({
        page = 1,
        limit = 20,
        status,
        type,
        search,
    }: {
        /**
         * Page number (starts from 1)
         */
        page?: number,
        /**
         * Number of items per page (max 200)
         */
        limit?: number,
        /**
         * Filter by status
         */
        status?: SecurityRequestStatus,
        /**
         * Filter by request type
         */
        type?: SecurityRequestType,
        /**
         * Search by client name, email, phone or address
         */
        search?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/security/requests',
            query: {
                'page': page,
                'limit': limit,
                'status': status,
                'type': type,
                'search': search,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
    /**
     * Count security requests by status
     * Number of pending and handled requests (menu badge).
     * @returns SecurityRequestCountsResponse
     * @throws ApiError
     */
    public securityDashboardControllerCounts(): CancelablePromise<SecurityRequestCountsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/security/requests/counts',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
    /**
     * Get a security request
     * Full request with the client, the location, a readable summary, the configurator answers and the estimate with its internal margin breakdown.
     * @returns AdminSecurityRequestDetailResponse
     * @throws ApiError
     */
    public securityDashboardControllerFindOne({
        id,
    }: {
        /**
         * Request ID
         */
        id: string,
    }): CancelablePromise<AdminSecurityRequestDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/security/requests/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Request not found.`,
            },
        });
    }
    /**
     * Update a security request
     * Marks a request handled / not handled and edits the internal note.
     * @returns AdminSecurityRequestDetailResponse
     * @throws ApiError
     */
    public securityDashboardControllerUpdate({
        id,
        requestBody,
    }: {
        /**
         * Request ID
         */
        id: string,
        requestBody: UpdateSecurityRequestDto,
    }): CancelablePromise<AdminSecurityRequestDetailResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/dashboard/security/requests/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Request not found.`,
            },
        });
    }
    /**
     * Get the configurator catalogue
     * Equipment references (purchase prices per plan, margin, computed sale prices, install time, supplies) and the global pricing parameters.
     * @returns SecurityCatalogResponse
     * @throws ApiError
     */
    public securityDashboardControllerGetCatalog(): CancelablePromise<SecurityCatalogResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/security/catalog',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
    /**
     * Update a catalogue item
     * Edits the label, variants, purchase prices, margin, install time or supplies of an equipment reference. SKUs are fixed.
     * @returns SecurityCatalogItemResponse
     * @throws ApiError
     */
    public securityDashboardControllerUpdateItem({
        sku,
        requestBody,
    }: {
        /**
         * Equipment reference
         */
        sku: string,
        requestBody: UpdateSecurityCatalogItemDto,
    }): CancelablePromise<SecurityCatalogItemResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/dashboard/security/catalog/items/{sku}',
            path: {
                'sku': sku,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Item not found.`,
            },
        });
    }
    /**
     * Update the pricing parameters
     * Edits labour rates, half-day rounding, commissioning and repair fees, installer cost, supplies margin and contingency.
     * @returns SecurityPricingSettingsResponse
     * @throws ApiError
     */
    public securityDashboardControllerUpdateSettings({
        requestBody,
    }: {
        requestBody: UpdateSecurityPricingSettingsDto,
    }): CancelablePromise<SecurityPricingSettingsResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/dashboard/security/catalog/settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
    /**
     * Simulate an estimate
     * Computes an estimate with the current catalogue, including the internal margin breakdown, to check prices after editing them.
     * @returns AdminSecurityEstimateResponse
     * @throws ApiError
     */
    public securityDashboardControllerEstimate({
        requestBody,
    }: {
        requestBody: SecurityConfigurationDto,
    }): CancelablePromise<AdminSecurityEstimateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/dashboard/security/estimates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
}
